import { call, put, takeEvery } from 'redux-saga/effects';
import { CoOpActionKeys, UpdateCoOpState } from '..';
import { ICoOpState, lookupActionCreators } from '../../lookups';
import { uiActionCreators } from '../../ui';
import * as api from '../coOpApi';

function* updateCoOpStateSaga(action: UpdateCoOpState) {
  yield put(uiActionCreators.showSpinnerDialog());
  const response: ICoOpState = yield call(api.updateCoOpState, action.payload);

  yield put(lookupActionCreators.setLookups({ partial: true, payload: { coOpStates: [response] } }));
  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchUpdateCoOpState() {
  yield takeEvery(CoOpActionKeys.UPDATE_COOP_STATE, updateCoOpStateSaga);
}
